import { render, staticRenderFns } from "./experience_reflection.vue?vue&type=template&id=bf153c54&scoped=true"
import script from "./experience_reflection.vue?vue&type=script&lang=js"
export * from "./experience_reflection.vue?vue&type=script&lang=js"
import style0 from "./experience_reflection.vue?vue&type=style&index=0&id=bf153c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf153c54",
  null
  
)

export default component.exports